<div class="task-step-b" [formGroup]="formGroup">
  <h2 class="col-12" *ngIf="false">Deliveries</h2>
  <div class="deliveries-wrapper" *ngIf="deliveries.length > 0; else noDeliveries">
    <div class="actions">
      <button
        type="button"
        class="btn btn-primary add-delivery"
        (click)="onAddDeliveryClick()"
        i18n="Add delivery button label at the task delivery configuration step of the task wizard@@addDeliveryButtonLabelTaskWizard"
      >Add Delivery</button>
    </div>
    <table class="table table-striped table-advance table-hover deliveries">
      <thead>
      <tr>
        <th class="subject" i18n="Column header for Subject at a table@@subjectColumnHeader">Subject</th>
        <th class="contacts" i18n="Column header for Contacts at a table@@contactsColumnHeader">Contacts</th>
        <th class="tags" i18n="Column header for tags at a table@@tagsColumnHeader">Tags</th>
        <th class="method" i18n="Column header for Method at a table@@methodColumnHeader">Method</th>
        <th class="filters" i18n="Column header for Filters at a table@@filtersColumnHeader">Filters</th>
        <th class="actions" i18n="Column header for Actions at a table@@actionsColumnHeader">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let delivery of deliveries">
        <td class="subject">{{ delivery.Subject }}</td>
        <td class="contacts">
          <div *ngIf="delivery.Contacts && delivery.Contacts.length" placement="top" ngbTooltip="{{ getContactNames(delivery.Contacts).join(', \n') }}">
            <span>{{ delivery.Contacts.length }}</span>
            <span style="margin-left: 4px" i18n="@@sufixContactsAfterNumberDeliveryTable">contacts</span>
          </div>
          <div *ngIf="!delivery.Contacts || !delivery.Contacts.length">---</div>
        </td>
        <td class="tags">
          <div *ngIf="delivery.Tags && delivery.Tags.length" placement="top" ngbTooltip="{{ getTagString(delivery.Tags) }}">
            <span>{{ delivery.Tags ? delivery.Tags.length : 0 }}</span>
            <span style="margin-left: 4px" i18n="@@sufixTagsAfterNumberDeliveryTable">tags</span>
          </div>
          <div *ngIf="!delivery.Tags || !delivery.Tags.length">---</div>
        </td>
        <td class="method">{{ delivery.Method }}</td>
        <td class="filters">
          <span placement="top" ngbTooltip="{{ getFilterLabel(delivery.Filters, 'tooltip') }}">{{ getFilterLabel(delivery.Filters, 'count') }}</span>
        </td>
        <td class="actions">
          <button class="btn btn-primary btn-xs" type="button" (click)="onEditDeliveryClick(delivery)"><i class="fa fa-pencil"></i></button>
          <button class="btn btn-danger btn-xs" type="button" (click)="onDeleteDeliveryClick(delivery)"><i class="fa fa-trash-o"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noDeliveries>
    <div class="missing-delivery-info">
      <h3 i18n="no delivery note|The message shown at the top of the delivery list when there are no deliveries registered to a task at the task edit form@@noRegisteredDeliveriesTitleTaskForm">There are no deliveries for this task yet.</h3>
      <p>
        <button
          type="button"
          class="btn btn-primary add-delivery"
          (click)="onAddDeliveryClick()"
          i18n="click here to add button label|The label of the button indicading that the button should be clicked to achieve a goal that is described at a label present at its right@@clickHereLabelAtRightButton"
        >Click here</button>
        <span i18n="the label describing add delivery to the click here button|The label at the right of the button indicading that the button should be clicked to add a new delivery to a task form@@addNewDeliveryButtonExplanation">to add a new delivery</span>
      </p>
      <p class="long-description" i18n="delivery description|The message explaining deliveries that is shown at the delivery list when there are no deliveries registered to a task at the task edit form@@noRegisteredDeliveriesDescriptionTaskForm">Deliveries allows you to send reports with specific messages and applied filters for different groups from your contact list.</p>
    </div>
  </ng-template>
</div>
